angular.module('aprima-core-ui').component('apPharmacyItem', {
    bindings: {
        pharmacy: '<'
    },
    templateUrl: '/core-ui/views/directives/find/apFindPharmacyTemplate.html',
    controllerAs: 'match',
    controller: ['_', function(_) {
        'use strict';

        this.$onChanges = function changes(changeObj) {
            if(changeObj.pharmacy && changeObj.pharmacy.currentValue) {
                this.model = _.assign({}, changeObj.pharmacy.currentValue);
                // Handle the case where pharmacy IS a MasterPharmacy, so it doesn't have a MasterPharmacy property
                // so use itself as the MasterPharmacy
                if(!this.model.MasterPharmacy) {
                    this.model.MasterPharmacy = _.assign({}, changeObj.pharmacy.currentValue);
                }
            }
        };
    }]
});